import React from 'react';
import Styles from './FooterCard.module.scss';

const FooterCard = ({ children, newUser }) => {
  return (
    <div
      className={`${Styles.card_container} ${newUser && Styles.new_user_btns}`}
    >
      <div className={Styles.card_container__card}>
        <div className={Styles.card_container__card__inner}>{children}</div>
      </div>
    </div>
  );
};

export default FooterCard;
